import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  Tooltip,
  Box,
  IconButton,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { useGetAllOrganizationsSelectQuery } from "../../../../middleware/apiOrganizations";
import { getEquipmentOptions, getUserRoleOptions, selectOrganization } from "../helpers";
import SelectSimpleSearch from "../../../components/SelectSimple/SelectSimpleSearch";
import { getAllOrganization } from "../helpers";
import { useGetFacFireCompSelectElementsQuery } from "../../../../middleware/facilitiesApi";
import { useGetEquipmentSystemsQuery } from "../../../../middleware/equipmentsApi";
import { useGetUserRolesSelectQuery } from "../../../../middleware/usersApi";
import { SelectMultipleChipDeletableWithSearchField } from "../../../components/SelectMultipleChipDeletableWithSearchField";
import { PossibilityOfViewingForm } from "../AddEmployee/Sections/PossibilityOfViewingForm";
import SelectGroupingMultipleCheckmarks from "../../../components/SelectGroupingMultipleCheckmarks";
import InputMaskPhone from "../../../components/InputMaskPhone";
import InputPassword from "../../../components/InputPassword";
import InputText from "../../../components/InputText";
import { BasicFrom } from "../AddEmployee/Sections/BasicForm";
import { FunctionalForm } from "../AddEmployee/Sections/FunctiolForm";
import SelectMultipleChipDeletable from "../../../components/SelectMultipleChipDeletable";
import CheckboxSimple from "../../../components/CheckboxSimple";
import Switcher from "../../../components/Switcher";
import { pagename } from "../constants";
import SelectSimpleWithClientSearch from "../../../components/SelectSimple/SelectSimpleWithClientSearch";
import { SelectSubdivision } from "../form-config";
export const formFields = {
  admin_employee: "admin_employee",

  fullName: "fullName",
  jobTitle: "jobTitle",
  phoneNumber: "phoneNumber",
  email: "email",
  login: "login",
  password: "password",
  roleId: "roleId",
  passwordRepeat: "passwordRepeat",
  organizationWorkingFor: "organizationWorkingFor",
  protectionObjectsIds: "protectionObjectsIds",
  equipmentKindsIds: "equipmentKindsIds",
  isContactPerson: "isContactPerson",
  objects_to_test: "Поставить на ТО",
  isActive: "isActive",
  organization_add_edit: "Создание/Редактирование организаций",
  all_organizations: "Чтение всех организаций",
  added_organizations: "Чтение добавленных организаций",

  availableOrganizations: "availableOrganizations",
  permissionsIds: "permissionsIds",
  subdivisionId: "subdivisionId",
};

export const formFieldsTable = {
  name: "name",
  executiveUsers: "executiveUsers",
  organizations: "organizations",
  equipmentKindsAndTypes: "equipmentKindsAndTypes",
  tasks: "tasks",
  edit: "edit",

  avatarLink: "avatarLink",
  employeeEquipmentKinds: "employeeEquipmentKinds",
  employeeFullName: "employeeFullName",
  employeePosition: "employeePosition",
  organizationType: "organizationType",
};

const ITEM_HEIGHT = 45;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
    },
  },
};

const SimpleSelect = ({ options, label, onChange, error, value, disabled = false, setValue, ...rest }) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth error={!!error} {...rest}>
      <InputLabel>{t(label)}</InputLabel>
      <Select
        value={value || ""}
        input={<OutlinedInput label={t(label)} />}
        onChange={onChange}
        MenuProps={MenuProps}
        sx={{
          ".MuiSelect-select": { height: 0 },
          ".MuiListItemText-root": { m: 0 },
        }}
        disabled={disabled}
      >
        {options.map((option, i) => (
          <MenuItem key={i} value={option?.value || ""} sx={{ height: ITEM_HEIGHT }}>
            <ListItemText primary={<Typography>{option.name?.toString() || option || ""}</Typography>} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

function getTopLevelTitles(arr) {
  return arr.map((item) => item.title);
}

export const ObjectsSelect = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const { data: facFireCompSelect = [] } = useGetFacFireCompSelectElementsQuery(searchValue);

  return (
    <SelectMultipleChipDeletableWithSearchField
      setSearchValue={setSearchValue}
      isIds={true}
      searchValue={searchValue}
      options={facFireCompSelect}
      {...props}
    />
  );
};

export const EquipmentKindSelect = (props) => {
  const { data: equipmentSelectElements = [] } = useGetEquipmentSystemsQuery("");

  const selectedOptions = useMemo(() => getEquipmentOptions(equipmentSelectElements), [equipmentSelectElements]);

  return <SelectMultipleChipDeletable {...props} options={selectedOptions} />;
};

export const OrganizationsSelectMultipleChipDeletable = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const { data: organizationsSelect = [] } = useGetAllOrganizationsSelectQuery(searchValue);

  const selectedOptions = useMemo(() => getAllOrganization(organizationsSelect), [organizationsSelect]);

  return (
    <SelectGroupingMultipleCheckmarks
      {...props}
      error={null}
      value={props.value}
      onChange={props.onChange}
      options={selectedOptions}
      setSearchValue={setSearchValue}
      searchValue={searchValue}
    />
  );
};

export const OrganizationsSelect = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const { data: organizationsSelect = [] } = useGetAllOrganizationsSelectQuery(searchValue);

  return (
    <SelectSimpleSearch
      {...props}
      sx={{ ".MuiTypography-root": { padding: 0 } }}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      options={selectOrganization(organizationsSelect)}
    />
  );
};
export const workingCorrectlyOptions = [
  { status: true, name: t("label:unbanned") },
  { status: false, name: t("label:banned") },
];

const UserRolesSelect = (props) => {
  const { data: OrganizationsSelectOptions = [] } = useGetUserRolesSelectQuery();

  return (
    <SelectSimpleWithClientSearch
      {...props}
      options={getUserRoleOptions(OrganizationsSelectOptions)}
      sx={{
        ".MuiTypography-root": { maxWidth: "180px", overflowX: "hidden" },
      }}
    />
  );
};
export const formConfigSwitcher = [
  {
    name: formFields.isActive,
    label: "label:isActive",
    type: "switch",
    options: workingCorrectlyOptions,
    sx: {
      "& .MuiSwitch-root": {
        "& .MuiSwitch-track": {
          backgroundColor: "red",
        },
      },
    },
    rules: {},
    input: (props) => <Switcher {...props} />,
  },
];
export const basicInformationConfig = [
  {
    id: 5,
    name: formFields.fullName,
    label: "label:fullName",
    type: "text",
    firstUpperCase: true,
    placeholder: "placeholder:fullName",
    flexBasis: "100%",
    additionalClassName: "contacts_form",
    rules: {
      required: true,
    },
    input: (props) => <InputText {...props} />,
  },
  {
    id: 7,
    name: formFields.phoneNumber,
    label: "label:phone",
    flexBasis: "100%",
    additionalClassName: "contacts_form",
    placeholder: "placeholder:phone",
    rules: {
      required: true,
      validate: (value, formValues) => value.replace(/[+() ]/g, "", "")?.length === 11,
    },
    input: (props) => <InputMaskPhone {...props} />,
  },
  {
    id: 9,
    name: formFields.login,
    label: "label:loginOrMail",
    type: "text",
    flexBasis: "100%",
    additionalClassName: "contacts_form",
    placeholder: "placeholder:loginOrMail",
    rules: {
      required: true,
    },
    input: (props) => <InputText {...props} />,
  },
  {
    id: 10,
    name: formFields.password,
    label: "label:password",
    type: "password",
    flexBasis: "100%",
    placeholder: "placeholder:password",
    additionalClassName: "contacts_form",
    rules: {
      validate: {
        lengthCheck: (value) =>
          value == null || value?.length >= 6 || value?.length == 0 || value == "" || "password_length",
      },
    },
    input: (props) => <InputPassword {...props} />,
  },
  {
    id: 11,
    name: formFields.passwordRepeat,
    label: "label:PasswordRepeat",
    placeholder: "placeholder:confirm_password",
    type: "password",
    flexBasis: "100%",
    additionalClassName: "contacts_form",
    rules: {
      validate: {
        matchPassword: (value, formValues) =>
          value === formValues[formFields.password] ||
          formValues[formFields.password].length == 0 ||
          formValues[formFields.password] == "" ||
          "password_not_match",
      },
    },
    input: (props) => <InputPassword {...props} />,
  },
  {
    id: 12,
    name: formFields.roleId,
    label: "label:role",
    placeholder: "Выберите роль сотрудника",
    type: "select-text",
    flexBasis: "100%",
    rules: {
      required: true,
    },
    input: (props) => <UserRolesSelect {...props} />,
  },
  {
    id: 13,
    name: formFields.subdivisionId,
    label: "Подразделения и группы",
    placeholder: "Выберите подразделение сотрудника",
    type: "select-text",
    flexBasis: "100%",
    rules: {
      required: true,
    },
    input: (props) => <SelectSubdivision {...props} />,
  },
];

export const functionalFormConfig = pagename.map((item) => ({
  name: `${item}`,
  label: `${item}`,
  type: "checkbox",
  rules: {},
  flexBasis: "25%",
  input: (props) => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          paddingRight: "20px",
        }}
      >
        <Box sx={{ width: "193px" }}>
          <CheckboxSimple {...props} />
        </Box>
        <Tooltip
          title={item}
          componentsProps={{
            tooltip: {
              sx: {
                color: "var(--black)",
                backgroundColor: "var(--white)",
                borderRadius: 0,
                maxWidth: 300,
              },
            },
          }}
        >
          <IconButton className="icon-btn" sx={{ height: "24px", width: "24px", padding: "0" }}>
            <InfoIcon sx={{ color: "var(--main)" }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  },
}));

export const possibilityOfViewingFormConfig = [
  {
    name: formFields.organization_add_edit,
    label: "label:add_edit_organizations",
    type: "checkbox",
    rules: {},
    flexBasis: "100%",
    input: (props) => <CheckboxSimple {...props} />,
  },
  {
    name: formFields.availableOrganizations,
    type: "select-multi",
    label: "title_page:organizations",
    rules: {},
    width: "49%",
    input: (props) => <OrganizationsSelectMultipleChipDeletable {...props} />,
  },
];

export const objectsToTestConfig = [
  {
    id: 1,
    name: formFields.roleId,
    label: "label:role",
    type: "select-text",
    flexBasis: "49%",
    rules: {
      required: true,
    },
    input: (props) => <UserRolesSelect {...props} />,
  },
  {
    id: 2,
    name: formFields.objects_to_test,
    label: "label:objects_to_test",
    type: "checkbox",
    rules: {},
    flexBasis: "100%",
    input: (props) => <CheckboxSimple {...props} />,
  },
];

export const sections = [
  {
    id: 1,
    title: "basic_information",
    Component: BasicFrom,
    config: basicInformationConfig,
  },
  {
    id: 2,
    title: "possibility_of_viewing",
    Component: PossibilityOfViewingForm,
    config: possibilityOfViewingFormConfig,
  },
  {
    id: 3,
    title: "role",
    Component: FunctionalForm,
    config: functionalFormConfig,
  },
];
